"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineRenderer1 = exports.transformBarX = exports.createSimpleBarOffset = exports.createBarOffset = exports.HighLightSpots = exports.getPath = void 0;
var react_1 = __importStar(require("react"));
var Chart_1 = require("./Chart");
function getPath(points, xNormalizer, yNormalizer) {
    var d = points.reduce(function (path, item) {
        if (path == "")
            return "M  ".concat(xNormalizer.normalize(item.x), " ").concat(yNormalizer.normalize(item.y), " ");
        return path + "L ".concat(xNormalizer.normalize(item.x), " ").concat(yNormalizer.normalize(item.y), " ");
    }, "");
    if (points.length == 1) {
        d += " L  ".concat(xNormalizer.normalize(points[0].x) + 1, " ").concat(yNormalizer.normalize(points[0].y), " ");
    }
    return d;
}
exports.getPath = getPath;
function HighLightSpots() {
    var _a = (0, react_1.useContext)(Chart_1.ChartContext), highLightSpots = _a.highLightSpots, xNormalizer = _a.xNormalizer, yNormalizer = _a.yNormalizer, height = _a.height, hidden = _a.hidden;
    if (!highLightSpots)
        return null;
    var allSpots = hidden ? highLightSpots.filter(function (s) { return !hidden.includes(s.serie.label); }) : highLightSpots;
    var spots = allSpots.filter(function (s) { return !['bar', 'simple-bar'].includes(s.serie.type); });
    if (!allSpots.length)
        return null;
    var x = allSpots[0].item.x;
    x = Math.round(xNormalizer.normalize(x));
    return react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: "M ".concat(x, " 0 L ").concat(x, " ").concat(height), className: "cross" }),
        spots.map(function (s) { return react_1.default.createElement("circle", { key: s.serie.style, className: s.serie.style, cx: xNormalizer.normalize(s.item.x), cy: yNormalizer.normalize(s.item.y), r: 6 }); }));
}
exports.HighLightSpots = HighLightSpots;
function Line(_a) {
    var _b;
    var serie = _a.serie, isHidden = _a.isHidden, chart = _a.chart;
    var xNormalizer = chart.xNormalizer, yNormalizer = chart.yNormalizer;
    var lineStyle = (_b = serie.lineStyle) !== null && _b !== void 0 ? _b : "area";
    var _c = (0, react_1.useMemo)(function () {
        var d = getPath(serie.data, xNormalizer, yNormalizer);
        var first = serie.data[0];
        var last = serie.data[serie.data.length - 1];
        var shadowArea = lineStyle == 'area' ? getPath(__spreadArray(__spreadArray([
            { x: first.x, y: yNormalizer.dataMin }
        ], serie.data, true), [
            { x: last.x, y: yNormalizer.dataMin },
        ], false), xNormalizer, yNormalizer) : null;
        var dots = lineStyle == 'dot' ? serie.data.map(function (p) { return ({ x: xNormalizer.normalize(p.x), y: yNormalizer.normalize(p.y) }); }) : null;
        return [d, shadowArea, dots];
    }, [serie, xNormalizer, yNormalizer]), d = _c[0], shadowArea = _c[1], dots = _c[2];
    return react_1.default.createElement("g", { key: "line-".concat(serie.style), className: "line ".concat(serie.style, " ").concat(isHidden ? 'line-hidden' : '') },
        react_1.default.createElement("path", { className: lineStyle == 'dashed' ? 'line-dashed' : '', key: "path", d: d }),
        shadowArea && react_1.default.createElement("path", { key: "shadow", className: "shadow-area", d: shadowArea }),
        dots && dots.map(function (d, i) { return react_1.default.createElement("circle", { key: i, cx: d.x, cy: d.y, r: 3, className: "line-dot" }); }));
}
function Circle(_a) {
    var serie = _a.serie, isHidden = _a.isHidden, chart = _a.chart;
    var xNormalizer = chart.xNormalizer, yNormalizer = chart.yNormalizer;
    return react_1.default.createElement("g", { key: "points-".concat(serie.style), className: "line ".concat(serie.style, " ").concat(isHidden ? 'line-hidden' : '') }, serie.data.map(function (d) { return react_1.default.createElement("circle", { cx: xNormalizer.normalize(d.x), cy: yNormalizer.normalize(d.y), r: 3 }); }));
}
function createBarOffset(series, width) {
    width *= .9;
    var maxEntries = (0, Chart_1.countMaxEntries)(series);
    var serieWidth = width / maxEntries - 20;
    var entryWidth = serieWidth / series.length;
    if (entryWidth > 50) {
        entryWidth = 50;
        serieWidth = entryWidth * series.length;
    }
    return { offsetBase: serieWidth * -.5, entryWidth: entryWidth };
}
exports.createBarOffset = createBarOffset;
function createSimpleBarOffset(series, width) {
    var _a;
    var size = ((_a = series[0].data) === null || _a === void 0 ? void 0 : _a.length) || 1;
    var entryWidth = width / size;
    return { offsetBase: entryWidth * -.5, entryWidth: entryWidth };
}
exports.createSimpleBarOffset = createSimpleBarOffset;
function transformBarX(chart) {
    var h = function (s) { return chart.hidden == null ? false : chart.hidden.includes(s); };
    var data = chart.data.filter(function (s) { return s.type == 'bar' && !h(s.label); });
    var layout = createBarOffset(data, chart.width);
    var xNormalizer = chart.xNormalizer;
    return function (serie, item) {
        if (serie.type != 'bar')
            return item;
        var index = data.findIndex(function (s) { return s == serie; });
        var x = (xNormalizer.normalize(item.x) + layout.offsetBase) + index * layout.entryWidth;
        x += layout.entryWidth / 2;
        x = xNormalizer.toDataScale(x);
        return __assign(__assign({}, item), { x: x, realX: item.x });
    };
}
exports.transformBarX = transformBarX;
function Bar(_a) {
    var serie = _a.serie, isHidden = _a.isHidden, chart = _a.chart;
    var xNormalizer = chart.xNormalizer, yNormalizer = chart.yNormalizer;
    var h = (0, Chart_1.useIsSerieHidden)();
    if (isHidden)
        return null;
    var data = chart.data.filter(function (s) { return s.type == 'bar' && !h(s.label); });
    var layout = createBarOffset(data, chart.width);
    var index = data.findIndex(function (s) { return s == serie; });
    var base = yNormalizer.normalize(0);
    return react_1.default.createElement("g", { key: "points-".concat(serie.style), className: "line ".concat(serie.style, " ").concat(isHidden ? 'line-hidden' : '') }, serie.data.map(function (d, key) {
        var x = (xNormalizer.normalize(d.x) + layout.offsetBase) + index * layout.entryWidth + 3;
        var y = yNormalizer.normalize(d.y);
        var height = Math.abs(y - base);
        var width = layout.entryWidth - 6;
        if (d.y < 0)
            y = base;
        var props = { x: x, y: y, height: height, width: width, key: key };
        return react_1.default.createElement("rect", __assign({}, props, { rx: 4 }));
    }));
}
function SimpleBar(_a) {
    var serie = _a.serie, isHidden = _a.isHidden, chart = _a.chart;
    var xNormalizer = chart.xNormalizer, yNormalizer = chart.yNormalizer, highLightSpots = chart.highLightSpots;
    var h = (0, Chart_1.useIsSerieHidden)();
    if (isHidden)
        return null;
    var data = chart.data.filter(function (s) { return s.type == 'simple-bar' && !h(s.label); });
    var layout = createSimpleBarOffset(data, chart.width);
    var index = data.findIndex(function (s) { return s == serie; });
    var base = yNormalizer.normalize(0);
    return react_1.default.createElement("g", { key: "points-".concat(serie.style), className: "line ".concat(serie.style, " ").concat(isHidden ? 'line-hidden' : '') }, serie.data.map(function (d, key) {
        var _a;
        var x = (xNormalizer.normalize(d.x) + layout.offsetBase) + index * layout.entryWidth;
        var y = yNormalizer.normalize(d.y);
        var height = Math.abs(y - base);
        var width = layout.entryWidth - 2;
        if (d.y < 0)
            y = base;
        var props = { x: x + 1, y: y, height: height, width: width, key: key };
        var hs = (_a = highLightSpots === null || highLightSpots === void 0 ? void 0 : highLightSpots[0]) === null || _a === void 0 ? void 0 : _a.item;
        if (hs && hs != d)
            props.opacity = 0.6;
        return react_1.default.createElement("rect", __assign({}, props));
    }));
}
function SerieRenderer(_a) {
    var serie = _a.serie, isHidden = _a.isHidden, chart = _a.chart;
    if (serie.data.length == 0)
        return null;
    var Renderer = (0, react_1.useMemo)(function () {
        if (serie.type == null || serie.type == 'line')
            return serie.data.length == 1 ? Circle : Line;
        if (serie.type == 'simple-bar')
            return SimpleBar;
        return Bar;
    }, [serie]);
    return react_1.default.createElement(Renderer, { key: serie.style, chart: chart, serie: serie, isHidden: isHidden });
}
function LineRenderer1() {
    var chart = (0, react_1.useContext)(Chart_1.ChartContext);
    var isHidden = (0, Chart_1.useIsSerieHidden)();
    return react_1.default.createElement(react_1.default.Fragment, null, chart.data.map(function (serie) { return react_1.default.createElement(SerieRenderer, { key: serie.style, chart: chart, isHidden: isHidden(serie.label), serie: serie }); }).reverse());
}
exports.LineRenderer1 = LineRenderer1;
//# sourceMappingURL=LineRenderer.js.map